import React from 'react';

import styled from 'styled-components';



const PullQuote = ({ block, ...props }) => {

  return (
    <Container>
      <blockquote>
        <p>{block.quote}</p>
      </blockquote>
    </Container>
  )
};


export default PullQuote;

const Container = styled.section`
  max-width: ${({ theme }) => theme.content.CONTENT_WIDTH};
  width: 90%;
  margin: 3em 0;
  display: flex;
  justify-content: center;


  p {
    font-size: 4em;
    color: ${({ theme }) => theme.colors.Primary};
    text-align: center;
  }
`;